exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container {\n  width: 400px;\n  height: 100vh;\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  border-left: 1px solid #c4c4c4;\n  transition: all 0.3s cubic-bezier(0.37, 0.18, 0, 0.96); }\n\n.add-bar-hidden {\n  margin-right: -400px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-add-bar/app-add-bar.component.scss
// module id = ../../../../../src/app/components/app-add-bar/app-add-bar.component.scss
// module chunks = main